const __WEBPACK_NAMESPACE_OBJECT__ = evite.exports.mobx;